import React from 'react';
import { Classable, HasChildren } from '@shapeable/types';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { WARM_GREY, PageContextDefinition, LayoutShell, SiteFooterLayout, UiConfig, UiProvider, KnowledgeHubPageProvider } from '@shapeable/ui';
import * as pageLayouts from './page-layouts';
import * as sliceLayouts from './slice-layouts';
import { LANG_STRINGS } from '../lang';
import { LayoutStyles, SYNC_BLUE, SYNC_BLUE_LIGHT, YELLOW, YELLOW_DARK, themeOverrides } from '../theme';
import { FeedEntriesProvider } from '../gatsby/providers/feed-entries-provider';


export type LayoutPropTypes = Classable & HasChildren & {
  path?: string;
  data?: any;
  pageContext?: PageContextDefinition;
};

const LayoutDefaultProps: LayoutPropTypes = {
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    ${LayoutStyles};
  `,
});

const FooterStyles = breakpoints({
  base: css`
  `,
});

const BodyStyles = breakpoints({
  base: css`
    flex-grow: 1;
  `,
});

// -------- Components -------->

const My = {
  Container: styled(LayoutShell)`${ContainerStyles}`,
  Body: styled.div`${BodyStyles}`,
  Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const Layout: React.FC<LayoutPropTypes> = (props) => {
  const { className, children } = props;

  const config: UiConfig = {
    layouts: { pageLayouts, sliceLayouts, defaultPageLayout: pageLayouts.PageLayoutDefault },
    langStrings: LANG_STRINGS,
    theme: themeOverrides,
    header: {
      variant: 'overlay',
      // showThemeMode: true,
    },
    search: {
      isAvailable: false,
    },
    menuBar: {
      // color: 'light',
      // buttonColor: 'light',
      // buttonHoverColor: 'dark',
      // backgroundColor: YELLOW_DARK,
      // isInverted: true,
    },
    entity:{
      dataProviders: [
       FeedEntriesProvider,
      ],
    },
    componentProps: {
      SiteMenuBar: {
        colors: {
          background: 'dark',
        }
      },
      NavigationMenuItem: {
        colors: {
          hover: {
            text: 'light',
          }
        }
      },
      MenuItemLink: {
        colors: {
          active: {
            text: SYNC_BLUE_LIGHT,
            border: SYNC_BLUE_LIGHT,
          },
          hover: {
            text: SYNC_BLUE_LIGHT,
          }
        }
      },
      MenuItem: {
        colors: {
          hover: {
            text: 'light',
          }
        }
      }
    }
  }

  return (
    <UiProvider value={config}>
      {/* /insights-5 */}
      <KnowledgeHubPageProvider 
      value={{
        path: '/insights-5'
      }}>
      <My.Container
        className={className}
        includeTooltip
        tooltipProps={{
          backgroundColor: '#FFFFFF',
        }}
      >
        <My.Body>
          {children}
        </My.Body>
        <My.Footer backgroundColor={WARM_GREY} />
      </My.Container>
      </KnowledgeHubPageProvider>
    </UiProvider>
  );
  
};

Layout.defaultProps = LayoutDefaultProps;

